import { useState, useRef, useEffect } from "react";
import CustomButton from "../lib/customButton";
import { AnimatePresence, motion } from "framer-motion";

const SpeedDial = ({
    label = "Adicionar",
    actions = [],
    buttonType = "confirm",
    disabled = false,
    className = ""
}) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div ref={ref} className={`relative inline-block ${className}`}>
            <CustomButton
                buttonType={buttonType}
                text={label}
                disabled={disabled}
                showIcon={false}
                onClick={() => setOpen((prev) => !prev)}
            />

            <AnimatePresence>
                {open && !disabled && (
                    <motion.div
                        initial={{ opacity: 0, y: -8 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -8 }}
                        transition={{ duration: 0.15 }}
                        className="absolute right-0 mt-2 w-52 bg-white border rounded-lg shadow-lg z-50"
                    >
                        <ul className="flex flex-col py-1">
                            {actions.map((action, index) => (
                                <li
                                    key={index}
                                    className="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                                    onClick={() => {
                                        setOpen(false);
                                        action.onClick?.();
                                    }}
                                >
                                    {action.icon && (
                                        <action.icon className="text-gray-600" />
                                    )}
                                    <span>{action.label}</span>
                                </li>
                            ))}
                        </ul>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default SpeedDial;
